import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=2bb5e22b&scoped=true&"
import script from "./StatusIndicator.vue?vue&type=script&lang=js&"
export * from "./StatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=2bb5e22b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb5e22b",
  null
  
)

export default component.exports